// styled
// type
// options
import Id from './Id';
import Profile from './Profile';
import { TableCellWrapper } from './style';

import type { ICell } from './type';

type CellType = 'common' | 'number' | 'center';

export interface ICommonCell extends ICell {
	cell_type?: CellType;
}

const TableCell = ({
	cell_type = 'common',
	_width,
	children,
	_margin,
	_padding,
	_onClick,
}: ICommonCell) => {
	return (
		<TableCellWrapper
			_width={_width}
			flex={cell_type === 'number' ? 'end' : cell_type === 'common' ? 'start' : 'center'}
			_margin={_margin}
			_padding={_padding ?? (cell_type === 'number' ? '0 16px 0 0 ' : '0px')}
			onClick={_onClick}
		>
			{typeof children === 'string' ? <p>{children}</p> : children}
		</TableCellWrapper>
	);
};

TableCell.Profile = Profile;
TableCell.Id = Id;

export default TableCell;
